var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('asc-role-dialog-grid-wrapper',_vm._g({attrs:{"title":_vm.title,"values":_vm.values,"grid-columns":_vm.gridColumns,"grid-filters":_vm.gridFilters,"on-open":_vm.onOpen,"all-resource-modules":_vm.allResourceModules}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }